import React from 'react'
import'./thanksPage.scss'
import { FcApproval } from "react-icons/fc";
import { Link } from 'react-router-dom';

const ThanksPage = () => {
  return (
    <div className="__fw">
      <div className="__mw">
        <div className="thx_wrp">
          <div className="img_wrp">
            <img src={require("../../img/check.webp")} alt="" />
          </div>
          <div className="tx_in">
            <h4>
              Thank you <br /> <em>For Participating!</em>{" "}
            </h4>
            <p>
              Thank you for taking the time to share your feedback! We truly
              appreciate your thoughts and support.
            </p>
            <br />
            <Link to={"https://www.chocodate.com/"}>
              <strong>
                Feel free to visit our website to discover more about us.
              </strong>
            </Link>
            <br />
            <Link to={"/"}>
              <small style={{ padding: "10px" }}>Home</small>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThanksPage
